import { Injectable } from '@angular/core';
import { ApiHttpClient } from 'ng2-app/http/clients/api';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpParams } from '@angular/common/http';
import { CXReport } from 'app/models/cx-report/cx-report.model';

@Injectable({
  providedIn: 'root'
})
export class CXPerformanceService {
  baseUrl = '/performance';

  constructor(
    private http: ApiHttpClient
  ) { }

  /**
   * Hit's the /reporting-performance endpoint to gather data based on whether a radio selection was made or the date
   * picker was used to define the date range.+
   *
   * @param startDate
   * @param endDate
   * @param radioSelection
   */
  getCXReports(autoRefresh: boolean): Observable<any> {
    const searchParams = new HttpParams()
      .set('autoRefresh', autoRefresh)
      .set('report', 'incoming-leads')
      .set('type', 'aggregate') // must be aggregate, time is not supported
      .set('group', 'lenderUser')
      .set('interval', 'DAY')
      .set('range', 'today');
    return this.http.get<CXReport[]>(`${environment.API_URL}/cx-performance`, { params: searchParams });
  }
}

